<template lang="pug">
  .landingpage
    //- TODO
</template>

<script>
import Page from '@/views/Page';

export default {
    name: 'LandingPage',
    extends: Page,
    components: {},
    methods: {
        // isAllowed(key) {
        //   return ['banner', 'slider'].includes(key);
        // }
    }
};
</script>

<style lang="sass" scoped>
section.slider,
section.banners
  padding: 0
section.heading
  padding-bottom: 0
</style>
